/**
 * Purpose: Row of module-level controls (search/filter slot on the left,
 *          actions on the right). Wraps cleanly on mobile instead of scrolling
 *          controls out of reach.
 * Inputs: children (leading controls), actions (node, trailing).
 * Outputs: responsive toolbar row.
 */
import React from 'react';

const DashboardToolbar = ({ actions = null, children = null }) => {
  if (!children && !actions) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">{children}</div>
      {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
};

export default DashboardToolbar;
